import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { OktaAuthGuard } from '@common_libraries/Services/routeSecurity/oktaGuard/okta-guard.service';
import { CompanyGuardService } from '@services/routeSecurity/companyGuard/company-guard.service';
import { PortfolioGuardService } from '@services/routeSecurity/portfolioGuard/portfolio-guard.service';
import { AccountSettingsGuardService } from '@services/routeSecurity/accountSettingsGuard/account-settings-guard.service';
import { DevAuthService } from '@common_libraries/Services/development/dev-auth.service';
import { LoginComponent } from '@login/login.component';
import {AccountActivationComponent} from '@login/components/AccountActivation/accountActivation.component';
import { PrivacyPolicyComponent } from '@privacy-policy/privacy-policy.component';
import { AccountSelectComponent } from '@accountSelect/account-select.component';
import { VerifyPasswordResetComponent} from '@login/components/VerifyPasswordReset/VerifyPasswordReset.component';
import {TermsOfUseComponent} from '@terms-of-use/terms-of-use.component';
import { InitialLandingPageComponent } from '@login/components/initial-landing-page/initial-landing-page.component';
import { NotFoundComponent } from '@not-found/not-found.component';
import { OktaCallbackComponent } from '@app/oktaCallback.component';
import { AnalysisGuardService } from './services/routeSecurity/analysisGuard/analysis-guard.service';
import { AnalysisSearchShareComponent } from './analysis/analysis-search-share/analysis-search-share.component';
import { DownloadHelper } from '@common_libraries/helpers/DownloadHelper';

const routes: Routes = [
  {
    path: '',
    children: [
        {
            path: '',
            redirectTo: 'analysis',
            pathMatch: 'full'
        },
        {
          path: 'analysis',
          loadChildren: () => import('./analysis/analysis.module').then(m => m.AnalysisModule),
          canActivate: [OktaAuthGuard, AnalysisGuardService],
          canActivateChild: [OktaAuthGuard, AnalysisGuardService],
          data: {
            title: 'Analysis Search'
          }
        }
    ]
  },
  
  {
    path: 'portfolios',
    loadChildren: () => import('./portfolio/portfolio.module').then(m => m.PortfolioModule),
    canActivate: [OktaAuthGuard],
    canActivateChild: [OktaAuthGuard],
    data: {
      title: 'Portfolio Search'
    }
  },
  {
    path: 'portfolio',
    loadChildren: () => import('./portfolio/portfolio.module').then(m => m.PortfolioModule),
    canActivate: [OktaAuthGuard],
    canActivateChild: [OktaAuthGuard],
    data: {
      title: 'Portfolio Search'
    }
  },
  {
    path: 'accountSettings',
    loadChildren: () => import('./accountSettings/account-settings.module').then(m => m.AccountSettingsModule),
    canActivate: [OktaAuthGuard],
    canActivateChild: [OktaAuthGuard],
    data: {
      title: 'Analysis Categories'
    }
  },
  {
    path: 'data',
    loadChildren: () => import('./data/data.module').then(m => m.DataModule),
    canActivate: [OktaAuthGuard],
    canActivateChild: [OktaAuthGuard],
    data: {
      title: 'Loss Files View'
    }
  },
  {
    path: 'sysAdmin',
    loadChildren: () => import('./sysAdmin/sys-admin.module').then(m => m.SysAdminModule),
    canActivate: [OktaAuthGuard],
    canActivateChild: [OktaAuthGuard],
    data: {
      title: 'System Admin'
    }
  },
  {
    path: 'folders',
    loadChildren: () => import('./folders/folders.module').then(m => m.FoldersModule),
    canActivate: [OktaAuthGuard],
    canActivateChild: [OktaAuthGuard],
    data: {
      title: 'Folder View'
    }
  },
  {
    path: 'accountSelect',
    pathMatch: 'full',
    component: AccountSelectComponent,
    data: {
      title: 'Select Account'
    }  },
  {
    path: 'login',
    pathMatch: 'full',
    component: LoginComponent,
    data: {
      title: 'TigerEye Login'
    }
  },
  {
    path: 'login/:reason',
    pathMatch: 'full',
    component: LoginComponent,
    data: {
      title: 'TigerEye Login'
    }
  },
  {
    path: 'callback',
    component: OktaCallbackComponent
  },
  {
    path: 'accountActivation',
    pathMatch: 'full',
    component: AccountActivationComponent,
    data: {
      title: 'Activate Account'
    }
  },
  // {
  //   path: 'verifypasswordreset',
  //   pathMatch: 'full',
  //   component: VerifyPasswordResetComponent,
  //   data: {
  //     title: 'Verify Password Reset'
  //   }
  // },
  {
     path: 'verifypasswordreset/:Guid',
     pathMatch: 'full',
     component: VerifyPasswordResetComponent,
     data: {
       title: 'Verify Password Reset'
     }
  },
  {
    path: 'termsOfUse',
    pathMatch: 'full',
    component: TermsOfUseComponent,
    data: {
      title: 'Terms Of Use'
    }
  },
  {
    path: 'privacyPolicy',
    pathMatch: 'full',
    component: PrivacyPolicyComponent,
    data: {
      title: 'Privacy Policy'
    }
  },
  {
    path: 'privacyPolicy/cookie',
    pathMatch: 'full',
    component: PrivacyPolicyComponent,
    data: {
      title: 'Privacy Policy'
    }
  },
  {
    path: '404',
    component: NotFoundComponent
  }
 ,
  {
    path: '**',
    redirectTo: '/404'
    
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, {}) ],
  exports: [ RouterModule ],
  providers: [
    DevAuthService,
    OktaAuthGuard,
    CompanyGuardService,
    PortfolioGuardService,
    AccountSettingsGuardService,
    DownloadHelper
  ]
})
export class AppRoutingModule {}
